import {Modal, Form, Row, Col, Button} from 'react-bootstrap';
import {useState, useMemo, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import API from '../helpers/api';
import moment from 'moment'
var dayOptions = [1, 7];
export default function GrantEntitlementModal({close, accountId, accountInfo}){
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const api = useMemo(() => new API({dispatch}), []);
    const [metadata, setMetadata] = useState(() => ({
        name: 'Temporary Entitlement',
        identifier: '',
        days: 1,
        startDate: moment().format('YYYY-MM-DDTHH:mm:ss.SSS'), //Include Time
        endDate: moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss.SSS')
    }));
    const [identifierOptions, setIdentifierOptions] = useState([{
        title: "The Cowboy Channel (TCC)",
        value: "tcc"
    },
    {
        title: "Everything NFR (NFR)",
        value: "everythingnfr"
    }]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMetadata(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const requestBody = {...metadata};

        if (metadata.days != 1){
            const endDate = moment(metadata.startDate).add(parseInt(metadata.days), 'days').format('YYYY-MM-DDTHH:mm:ss.SSS');
            requestBody.endDate = endDate;
        }

        try {
            const response = await api.grantEntitlementToAccount(accountId, requestBody);
            if (response) {
                alert("Entitlement granted successfully.");
                close();
            } else {
                alert("Failed to grant entitlement. Please try again.");
            }
        } catch (error){
            console.error('Error granting entitlement:', error);
            alert("Unable to grant entitlement. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
        
    }

    if (!accountId || !accountInfo) return null;
   
    return (
        <Modal show onHide={close} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Granting Entitlement for {accountInfo.firstName} {accountInfo.lastName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <h3>Entitlement Details</h3>
                    <p>Entitlement is temporary and is only good for 24 hours.</p>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="name">
                                <Form.Label>Entitlement Name</Form.Label>
                                <Form.Control 
                                    type="text"
                                    name="name"
                                    value={metadata.name}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="identifier">
                                <Form.Label>Identifier</Form.Label>
                                <Form.Select
                                    name="identifier"
                                    value={metadata.identifier}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Identifier</option>
                                    {identifierOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.title}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Form.Group controlId="endDate">
                            <Form.Label>Entitlement Length</Form.Label>
                            <Form.Select
                                name="days"
                                value={metadata.days}
                                onChange={handleChange}
                            >
                                {dayOptions.map(option => (
                                    <option key={option} value={option}>
                                        {option} day{option > 1 ? 's' : ''}
                                    </option>
                                ))}
                                {user?.user?.is_admin && (
                                    <option key={14} value={14}>14 days</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Button variant="secondary" onClick={close} disabled={isSubmitting} className="me-2">
                            Cancel
                        </Button>
                        <Button type="submit" disabled={isSubmitting || !metadata.name || !metadata.identifier}>
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </Button>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
